import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import { localize } from 'react-localize-redux';
import styled from 'styled-components';
import RaisedButton from 'material-ui/RaisedButton';
import Divider from 'material-ui/Divider';
import { translate } from 'react-i18next';

import PageBase from '../components/PageBase';
import i18n from '../translations/i18n';

const PageBaseStyled = styled(PageBase)`
  margin-top: 10px !important;
`;

const Title = styled.h3`
  padding: 10px;
  background-color: #54708a;
  margin-top: 10px;
  color: white;
`;

const Protocol = styled.h4`
  margin: 15px 0;
`;

const StyledSubmitButton = styled(RaisedButton)`
  float: right;
`;

const Container = styled.div``;

const StyledDivider = styled(Divider)`
  margin: 20px 0 !important;
`;
/*
  PropTypes / DefaultProps
 */
const propTypes = {
  content: PropTypes.object,
  title: PropTypes.string,
  onChange: PropTypes.any,
  lang: PropTypes.any,
};

const defaultProps = {};

class Message extends React.Component {
  constructor(props) {
    super(props);
    this.message = null;
  }

  componentWillMount() {
    this.message = this.props.content;
  }

  fieldChange = (event, newValue) => {
    const name = event.target.name;
    this.message[name] = newValue;
    this.props.onChange(this.message);
  };

  render() {
    if (
      (!this.props.content && !this.props.lang) ||
      this.props.content.lang !== this.props.lang ||
      !['EMAIL', 'PUSH'].includes(this.props.content.protocol)
    ) {
      return null;
    }

    const isEmail = this.props.content.protocol === 'EMAIL';

    return (
      <Container>
        {isEmail && (
          <div>
            <Title>{this.props.t(this.props.content.type)}</Title>
            <TextField
              floatingLabelText={this.props.t('email_subject')}
              name="title"
              defaultValue={this.props.content.title}
              fullWidth
              maxLength="50"
              onChange={this.fieldChange}
            />
            <br />

            <TextField
              defaultValue={this.props.content.body}
              name="body"
              floatingLabelText={this.props.t('email_message')}
              fullWidth
              onChange={this.fieldChange}
              multiLine
            />
            <br />
          </div>
        )}

        {!isEmail && (
          <div>
            <TextField
              defaultValue={this.props.content.body}
              name="body"
              floatingLabelText={this.props.t('push_message')}
              fullWidth
              maxLength="100"
              onChange={this.fieldChange}
              multiLine
            />
            <br />
          </div>
        )}
      </Container>
    );
  }
}

Message.propTypes = propTypes;
Message.defaultProps = defaultProps;

const extended = translate(['translations'], { i18n })(Message);
export default localize(extended, 'locale');



// WEBPACK FOOTER //
// ./src/components/Message.js